import actions from './actions'

const state = {}

const validate = {
  namespaced: true,
  state,
  actions
}

export default validate
